/**
 * Compact label + value pair used inside dashboard widget cards as part
 * of a multi-stat grid (e.g., "Operations Status", "Portfolio Overview").
 *
 * Consumed by ExecutiveDashboard and SafetyManagerDashboard. Reconciled
 * from the prior local `MiniStat` definitions.
 */
export interface StatCardProps {
  label: string;
  value: number | string;
}

export function StatCard({ label, value }: StatCardProps) {
  return (
    <div>
      <p className="text-2xl font-bold">{value}</p>
      <p className="mt-0.5 text-xs text-muted-foreground">{label}</p>
    </div>
  );
}
